import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { curry, compose } from '@cullylarson/f';
import { getStateFromAbbrev } from '@@client/lib/locations';
export var preferredStateOrder = ['OR', 'WA', 'CA', 'NV'];
export var joinReact = function joinReact(a, sep, b) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [a, sep, b]
  });
};
export var getStoreName = function getStoreName(storeInfo) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
  if (!storeInfo) return '';
  return storeInfo.name || joinReact(storeInfo.city, sep, storeInfo.state);
};
export var getStoreNameFullPlain = function getStoreNameFullPlain(storeInfo) {
  var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
  if (!storeInfo) return '';
  return storeInfo.name || [storeInfo.city, getStateFromAbbrev(storeInfo.state)].join(sep);
};

var groupLocationsByState = function groupLocationsByState(xs) {
  return xs.reduce(function (acc, x) {
    var state = x.state || x.locationState;
    if (!acc[state]) acc[state] = [];
    acc[state].push(x);
    return acc;
  }, {});
};

var orderGroupedLocationsByState = curry(function (order, locationsByState) {
  var result = {}; // first add the items that are in the order

  order.forEach(function (abbrev) {
    if (locationsByState[abbrev]) result[abbrev] = locationsByState[abbrev];
  }); // then add the items that aren't in the order

  Object.keys(locationsByState).forEach(function (abbrev) {
    // don't add it if it's in the order because it's already been added above
    if (order.includes(abbrev)) return;
    result[abbrev] = locationsByState[abbrev];
  });
  return result;
});
export var groupLocationsByStateOrdered = function groupLocationsByStateOrdered() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : preferredStateOrder;
  var locations = arguments.length > 1 ? arguments[1] : undefined;
  return compose(orderGroupedLocationsByState(order), groupLocationsByState)(locations);
};